import {
  encodedObjectsMap,
  formatColumnName,
  getNamespace,
} from "@permutation-city/common";
import { useDozerQuery } from "./useDozerQuery";

export type Incentive = {
  action: number;
  dataHash: string;
  objectId: number;
  tokenAmount: bigint;
  reputationAmount: bigint;
};

export function useIncentivesQuery() {
  const sqlQuery = `
SELECT
  "${formatColumnName("dataHash")}",
  "${formatColumnName("tokenAmount")}",
  "${formatColumnName("reputationAmount")}",
  "${formatColumnName("action")}"
FROM "${getNamespace()}${formatColumnName("Incentive")}"
WHERE "${formatColumnName("action")}" = 5
`;

  return useDozerQuery<Incentive[], [Incentive[]]>({
    sqlQuery,
    select: (data) => {
      const incentives = data[0];
      return incentives?.map((incentive) => ({
        ...incentive,
        objectId: encodedObjectsMap[incentive.dataHash],
      }));
    },
    fields: {
      datahash: "dataHash",
      tokenamount: "tokenAmount",
      reputationamount: "reputationAmount",
    },
    format: {
      tokenAmount: (value) => BigInt(value),
      reputationAmount: (value) => BigInt(value),
    },
  });
}
